import { render, staticRenderFns } from "./PrkAnimatedDescription.vue?vue&type=template&id=011f43d4&"
import script from "./PrkAnimatedDescription.vue?vue&type=script&lang=js&"
export * from "./PrkAnimatedDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports